import Helper from './Helper';

class CategoryNav {
  constructor() {
    const activeMenu = document.querySelector('.main-menu__item--level-2.main-menu__item--active, .main-menu__item--level-2.main-menu__item--parent-active');

    if(!!activeMenu){
      const categoryMenu = activeMenu.querySelector('.main-menu--level-3');

      if(categoryMenu){
        const categoryMenuItems = Array.prototype.slice.call(categoryMenu.querySelectorAll('li'));
        const categoryTitle = activeMenu.dataset.chaptertitle;
        const content = document.querySelector('.content');

        this.print(content, categoryTitle, categoryMenuItems);
      }
    }
  }

  print(content, title, categoryMenuItems){
    let list = '';
    categoryMenuItems.forEach(element => {
      if(!!element.innerHTML){
        list += element.innerHTML;
      }
    });

    const html = `
      <p class="category-nav__title">
        ${title}
        </p>
        <div class="category-nav__list">
        ${list}
      </div>
    `;
    const div = document.createElement('div');
    div.classList.add('category-nav');
    div.innerHTML = html;

    content.prepend(div);
    const activeLink = document.querySelector('.category-nav__list [href="' + window.location.href + '"]');
    if ( activeLink )
      activeLink.classList.add('active');
  }

} export default CategoryNav;
